import { Box, styled } from '@material-ui/core';
import { STabs } from '@setvi/shared/components';
import {
  ProductDetailsTab,
  ProductDetailsTabsIds
} from '@setvi/shared/interfaces';
import { useFlags } from 'launchdarkly-react-client-sdk';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2, 2, 4)
}));
export const TabNames = {
  [ProductDetailsTabsIds.WAREHOUSE]: 'Warehouse',
  [ProductDetailsTabsIds.ASSOCIATED_RESOURCE]: 'Resources',
  [ProductDetailsTabsIds.ASSOCIATED_PRODUCTS]: 'Options and Accessories',
  [ProductDetailsTabsIds.SIMILAR_PRODUCTS]: 'Similar Products',
  [ProductDetailsTabsIds.PRODUCT_INFO]: 'Product Info',
  [ProductDetailsTabsIds.SALES_ENABLEMENT]: 'Sales Kit',
  [ProductDetailsTabsIds.ORDER_HISTORY]: 'Order History',
  [ProductDetailsTabsIds.PRODUCT_ENHANCER]: 'Product Enhancer',
  [ProductDetailsTabsIds.PRODUCT_ASSISTANT]: 'Ask AI'
};
interface ProductDetailsTabsProps {
  tabs: ProductDetailsTab[];
  currentTab: ProductDetailsTabsIds;
  orderHistoryValues: boolean;
  onTabChange: (tab: ProductDetailsTabsIds) => void;
}
export const Tabs = ({
  currentTab,
  tabs = [],
  orderHistoryValues,
  onTabChange
}: ProductDetailsTabsProps) => {
  const flags = useFlags();
  const list = tabs
    .map(tab => ({
      label: TabNames[tab.id] || '-',
      value: tab.id,
      visible: () => {
        if (tab.id === ProductDetailsTabsIds.SIMILAR_PRODUCTS)
          return flags.productsSimilarProducts;

        if (tab.id === ProductDetailsTabsIds.ORDER_HISTORY)
          return flags.orders && orderHistoryValues;

        return true;
      }
    }))
    .filter(i => i.visible());

  return (
    <Container>
      <STabs
        type="rounded"
        tabsList={[
          ...list,
          ...(flags.salesEnablement
            ? [
                {
                  label: TabNames[ProductDetailsTabsIds.SALES_ENABLEMENT],
                  value: ProductDetailsTabsIds.SALES_ENABLEMENT,
                  visible: () => flags.salesEnablement
                }
              ]
            : []),
          ...(flags.productEnhancer
            ? [
                {
                  label: TabNames[ProductDetailsTabsIds.PRODUCT_ENHANCER],
                  value: ProductDetailsTabsIds.PRODUCT_ENHANCER,
                  visible: () => flags.productEnhancer
                }
              ]
            : []),
          ...(flags.productAssistant
            ? [
                {
                  label: TabNames[ProductDetailsTabsIds.PRODUCT_ASSISTANT],
                  value: ProductDetailsTabsIds.PRODUCT_ASSISTANT,
                  visible: () => flags.productAssistant
                }
              ]
            : [])
        ]}
        currentTab={currentTab}
        handleTabChange={onTabChange}
        divider={false}
        tabStyle={{ padding: '10px 12px' }}
      />
    </Container>
  );
};
